import React, { Component } from "react";
// login-component
import LoginComponent from "../../landing/login-component";
class Signup extends Component {
  render() {
    return <LoginComponent />;
  }
}

export default Signup;
